import { useState } from 'react';
import { CardItem } from '@/interface/card';
import './Card.css';

export default function Card(props: CardItem) {
  const image = require('/src/assets/card/' + props.icon + '.png');
  return (
    <section className="Card">
      <section className="icon">
        <img src={image} alt="" />
      </section>
      <section className="value">
        <span>{props.value}</span>
        <span className="sub-title">{props.subTitle}</span>
      </section>
      <section className="title">{props.title}</section>
      {/* <section className="desc">{props.desc}</section> */}
    </section>
  )
}